import { render, staticRenderFns } from "./UpdateAlertStatus.vue?vue&type=template&id=2e7faa3b"
import script from "./UpdateAlertStatus.vue?vue&type=script&lang=js"
export * from "./UpdateAlertStatus.vue?vue&type=script&lang=js"
import style0 from "./UpdateAlertStatus.vue?vue&type=style&index=0&id=2e7faa3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports